/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';
import { dependentKeyCompat } from '@ember/object/compat';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import dayjs from 'dayjs';
import { getLocalTime } from 'frontend-utils/utils/dayjs';
import generateOtaLink from 'frontend-utils/utils/url/generate-ota-link';

interface GeneralTablesCellsCellLiveViewSignature {
  Args: {
    period: unknown;
    source: unknown;
  };
}

export default class GeneralTablesCellsCellLiveView extends Component<GeneralTablesCellsCellLiveViewSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  @computed(
    // eslint-disable-next-line ember/use-brace-expansion
    'args.period.{fromDate,los}',
    'args.{persons,source}',
    'hotel.hotelinfo.id',
    'hotel.{id,isTripadvisorRebranding}',
  )
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get geoInsightLink() {
    return generateOtaLink(
      // @ts-expect-error: Incorrect type
      this.args.source, // ota
      this.hotel?.hotelinfo?.id, // hotelinfo id
      this.hotel?.id, // hotel id
      this.hotel?.isTripadvisorRebranding, // isTripadvisorRebranding
      this.args.period, // period
      2, // persons
      'app_parity', // type
      '', // city
      '', // pos
    );
  }

  @dependentKeyCompat
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hotel() {
    return this.hotelAndMarketService.hotel;
  }

  @computed('args.period.fromDate', 'hotel.hotelinfo.timezone')
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isGeoInsightDisabled() {
    // @ts-expect-error: Incorrect type
    const today = getLocalTime(this.hotel?.hotelinfo?.timezone);

    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return dayjs(this.args.period?.fromDate).isBefore(today, 'day');
  }

  <template>
    {{#unless this.isGeoInsightDisabled}}
      <a href={{this.geoInsightLink}} rel="noopener noreferrer" target="_blank">
        <span class="table-prism-icon">
          <PrismIcon @name="visibility-on" @size="small" />
        </span>
      </a>
    {{/unless}}
  </template>
}
